import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getSources } from '../services/personService'
import useNotifications from './useNotifications'

export default function usePersonSources(personId) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [sources, setSources] = useState()

  const fetchSources = useCallback(() => {
    if (personId) {
      getSources(personId)
        .then((resp) => {
          if (resp.status === 200) {
            setSources(resp.data)
          }
        })
        .catch((err) => {
          error(
            t('hooks.errors.gettingSourcesForPerson', {
              defaultValue: `Error getting sources for person: ${err.message || ''}`,
              message: err.message || '',
            }),
            err
          )
        })
    }
  }, [personId, error, t])

  useEffect(() => {
    fetchSources()
  }, [fetchSources])

  return { sources }
}
